import { FC } from 'react';
import { useParams } from 'react-router-dom';
import FormGroup from 'components/form/FormGroup';
import Form from 'components/form/Form';
import { useTranslation } from 'react-i18next';
import Employees from './Employees';
import { IInputs } from './types';

interface IProps {
  title: string;
  methods: any;
  handleSubmit: (data: IInputs) => void;
  btnLabel: string;
}

const RoleForm: FC<IProps> = ({ title, methods, handleSubmit, btnLabel }: IProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  return (
    <>
      <Form
        title={title}
        methods={methods}
        onSubmit={handleSubmit}
        btnLabel={btnLabel}
        isHorizontal
      >
        <FormGroup
          controlId="formGroupName"
          label={t('structure.roles.name')}
          type="text"
          name="name"
          isRequired
          isHorizontal
        />
      </Form>
      {id && <Employees groupId={id} />}
    </>
  );
};

export default RoleForm;
